<template>
  <div>
    <!-- 0429 수정 -->
    <el-row type="flex" justify="space-between" :gutter="20">
      <el-col :span="12">
        <w-syslog-rule-table @target-change="targetChange"></w-syslog-rule-table>
      </el-col>
      <el-col :span="12">
        <w-syslog-rule-target-table :selected-rule="selectedRule"></w-syslog-rule-target-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import WSyslogRuleTable from './components/SyslogRuleTable';
import WSyslogRuleTargetTable from './components/SyslogRuleTargetTable';

export default {
  name: 'WSyslogRule',
  components: {
    WSyslogRuleTable,
    WSyslogRuleTargetTable,
  },
  data() {
    return {
      selectedRule: {},
    };
  },
  methods: {
    targetChange(data) {
      this.selectedRule = data;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log/Syslog/SyslogRule.vue